import { palette } from "@powerdiary/components-library/lib";

export const getIndicatorColor = (label: string) => {
    const colorMap = {
        morning: palette.dusk["200"],
        afternoon: palette.sunflower["300"],
        evening: palette.twilight["100"],
    };
    return colorMap[label.toLowerCase() as keyof typeof colorMap];
};
